module.exports = __webpack_public_path__ + "img/yl3034.f70f37e5.png";